export const PRECLASS_CODES = ['preClassEduRecord']
export const PRECLASS_GROUP = 'preClassEduReport'

export const REALNAME_GROUPS = [
  { label: '管理报表', value: 'managerReport' },
  { label: '查询报表', value: 'findReport' }
]

export const PRECLASS_GROUPS = [
  { label: '班前教育报表', value: PRECLASS_GROUP }
]

export const GROUP_SORT_BASE = {
  managerReport: 100,
  findReport: 200,
  preClassEduReport: 300
}

export function groupSortBase(code) {
  return GROUP_SORT_BASE[code] || 900
}

export function templateGroupKey(item) {
  if (isPreClassTemplate(item)) return PRECLASS_GROUP
  return (item && (item.templateGroupCode || item.groupCode || item.group)) || 'findReport'
}

export function isPreClassTemplate(item) {
  if (!item) return false
  const code = item.templateCode || item.code || ''
  const group = item.templateGroupCode || item.groupCode || item.group || ''
  if (PRECLASS_CODES.indexOf(code) >= 0) return true
  return group === PRECLASS_GROUP
}

export function filterByCategory(list, category) {
  return (list || []).filter((item) => {
    const preClass = isPreClassTemplate(item)
    return category === 'preClass' ? preClass : !preClass
  })
}

export function categoryLabel(category) {
  return category === 'preClass' ? '班前教育' : '劳务用工'
}

export const ORG_TYPE_OPTIONS = [
  { label: '企业', value: 'com' },
  { label: '工程', value: 'bigPro' },
  { label: '标段', value: 'simPro' },
  { label: '劳务公司', value: 'laborCom' }
]

export function parseOrgTypes(value) {
  if (Array.isArray(value)) {
    return value.filter(Boolean)
  }
  return String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}

export function labelOrgTypes(value) {
  const map = {}
  ORG_TYPE_OPTIONS.forEach((item) => {
    map[item.value] = item.label
  })
  const labels = parseOrgTypes(value).map((code) => map[code] || code)
  return labels.length ? labels.join('、') : '—'
}

function sortNum(value) {
  const n = Number(value)
  return Number.isFinite(n) ? n : 99999
}

export function buildTemplateTree(rows, groupOptions) {
  const groups = []
  const map = {}
  ;(groupOptions || []).forEach((item) => {
    const node = {
      uid: 'group-' + item.value,
      isGroup: true,
      templateName: item.label,
      templateGroupCode: item.value,
      templateGroupName: item.label,
      sort: String(groupSortBase(item.value)),
      children: []
    }
    map[item.value] = node
    groups.push(node)
  })
  ;(rows || []).forEach((row) => {
    const code = row.templateGroupCode || ((groupOptions && groupOptions[0] && groupOptions[0].value) || 'findReport')
    if (!map[code]) {
      const node = {
        uid: 'group-' + code,
        isGroup: true,
        templateName: row.templateGroupName || code,
        templateGroupCode: code,
        templateGroupName: row.templateGroupName || code,
        sort: String(groupSortBase(code)),
        children: []
      }
      map[code] = node
      groups.push(node)
    }
    const child = Object.assign({}, row, {
      isGroup: false,
      uid: row.uid || row.customUid || 'tpl-' + (row.templateCode || groups.length + '-' + map[code].children.length)
    })
    delete child.children
    delete child.hasChildren
    map[code].children.push(child)
  })
  groups.forEach((group) => {
    group.children.sort((a, b) => sortNum(a.sort) - sortNum(b.sort))
  })
  return groups
}

export function isTemplateVisible(value) {
  if (value === false) return false
  const text = String(value == null ? '' : value)
    .trim()
    .toLowerCase()
  if (!text) return true
  return text === 'true' || text === 't' || text === '1' || text === 'yes'
}

export function isUserCustomTemplate(row) {
  return isTemplateVisible(row && row.userCustom) || (row && row.templateFlg === 'userCustom')
}

export function sanitizeTemplateMark(value) {
  if (value === true || value === false) return ''
  const text = String(value == null ? '' : value).trim()
  const lower = text.toLowerCase()
  if (!text || lower === 'true' || lower === 'false' || lower === 't' || lower === 'f') {
    return ''
  }
  return text
}

export function decorateTemplateTree(tree, mode) {
  return (tree || [])
    .filter((item) => item && item.children && item.children.length)
    .map((group) => {
      const children = (group.children || []).map((row) => {
        const types = parseOrgTypes(row.applicableOrgTypes || 'simPro,laborCom')
        const visible = isTemplateVisible(row.isShow)
        const userCustom = isUserCustomTemplate(row)
        return Object.assign({}, row, {
          uid: mode === 'org' ? row.customUid || row.uid : row.uid,
          showLabel: visible ? (mode === 'org' ? '启用' : '是') : mode === 'org' ? '停用' : '否',
          orgTypesLabel: labelOrgTypes(row.applicableOrgTypes),
          userCustomLabel: userCustom ? '用户定制' : '',
          applicableOrgTypeList: types,
          applicableOrgTypes: types,
          isShow: visible ? 'true' : 'false',
          userCustom: userCustom ? 'true' : 'false',
          mark: sanitizeTemplateMark(row.mark)
        })
      })
      return Object.assign({}, group, {
        showLabel: '',
        orgTypesLabel: '',
        userCustomLabel: '',
        templateCode: '',
        children: children
      })
    })
}

export function swapAdjacentSort(current, neighbor) {
  if (!current || !neighbor || current.isGroup || neighbor.isGroup) return []
  const left = String(current.sort || '')
  const right = String(neighbor.sort || '')
  if (!left || !right || left === right) return []
  return [
    {
      uid: current.uid,
      templateCode: current.templateCode,
      sort: right
    },
    {
      uid: neighbor.uid,
      templateCode: neighbor.templateCode,
      sort: left
    }
  ]
}
